import { Accordion } from '@/components/molecules/Accordion'
import { AccordionItem } from '@/components/molecules/AccordionItem'
import { Link, Tab, TabsNavigation, Icon } from '@/components/atoms'
import { FileUploadWithModal,ReviewProductsTable } from '@/components/organisms'
import { useInfiniteScrollTable } from '@/hooks/useInfiniteScrollTable'
import { getFormattedDate } from '@/utils/commons'
import { ROUTES } from '@/utils/constants/routesConstants'
import { useNavigate } from 'react-router-dom'
import './reviewAccordion.scss'
import { useAppSelector } from '@/store'
import { Constants, FILE_UPLOAD_TEMPLATE_TYPE } from '@/utils/constants/commonConstants'
import { ReviewDisplayContentTab, ReviewParentChildTab } from '@/containers'
import { useEffect, useState, useMemo } from 'react'
import { TARGET_TYPES } from '@/utils/constants/saleTargetConstants'
import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'
import { ButtonIcon } from 'pepsico-ds'
import { ReviewRow } from '@/containers/ReviewRow'
import getTargetRules from '@/helpers/targetRulesHelper'
import {COUNTRY_CODES} from '@/utils/constants/globalConstants'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {getSasToken} from '@/services/sasToken'
import {useAzureBlob} from '@/hooks/useAzureBlob-hook'

function ReviewAccordion({ salesTargetData, languages, handleTabClick, activeLanguage, activeTab = 'parent', editPanel, status, preRequisiteParentTab, preRequisiteChildTab, handleSetActiveTab, getFilteredProducts, onTemplateUpdate = () => {},salesTargetId }) {
  const navigate = useNavigate()
  const { downloadFileOnBlob } = useAzureBlob()
  //const { formData } = salesTargetData
  const { isAllCategories, isAllCategoriesChild, selectedType } = useAppSelector(state => state.salesTarget);
  const parentSelectedCategory = useAppSelector(state => state.salesTarget.tabWiseData.parent.selectedCategory);
  const childSelectedCategory = useAppSelector(state => state.salesTarget.tabWiseData.child.selectedCategory);
  const [openUpload, setOpenUpload] = useState(false)
  const [formData, setFormData] = useState(salesTargetData.formData)
  const countryCode = useAppSelector(selectCountryCode)

  useEffect(() => {
    // Keep local formData in sync with salesTargetData changes
    setFormData(salesTargetData.formData)
  }, [salesTargetData.formData])

  const filteredProducts = useMemo(() => getFilteredProducts ? getFilteredProducts() : [], [getFilteredProducts]);
  const tableData = useInfiniteScrollTable(filteredProducts);

  const getAnswer = val => (val ? 'Yes' : 'No')
  const [selectedTab, setSelectedTab] = useState(activeTab);
  const [selectedTabForProduct, setSelectedTabForProduct] = useState(activeTab);

  useEffect(() => {
    setSelectedTab(activeTab)
    setSelectedTabForProduct(activeTab)
  }, [activeTab])

  const handleTabChange = (tab, section) => {
    section === 'display-content' ? setSelectedTab(tab) : setSelectedTabForProduct(tab)

  }

  const handleEditSection = route => {
    if (salesTargetData.status === Constants.Draft) {
      editPanel(route);
    } else {
      handleSetActiveTab();
      navigate(route, { state: { isEdit: true} });
    }
  }
  const fileName = formData?.storeList?.split('/')?.pop()

  const getSelectedCategoryTitle = () => {
    let newSelectedCategory = parentSelectedCategory
    let isAllCategoriesNew = isAllCategories

    if (isPrerequisiteTarget && selectedTabForProduct === 'child') {
      newSelectedCategory = childSelectedCategory
      isAllCategoriesNew = isAllCategoriesChild
    }

    if (isAllCategoriesNew && selectedType !== Constants.UploadedProducts) {
      return 'All Categories'
    } else if (newSelectedCategory?.length > 0 && selectedType !== Constants.UploadedProducts) {
      if (typeof (newSelectedCategory[0]) == 'object') {
        return newSelectedCategory?.map(item => item?.displayText).join(', ')
      } else {
        return newSelectedCategory?.map(item => item).join(', ')
      }
    } else {
      return 'No Category Selected'
    }
  }

  const isPrerequisiteTarget =
    salesTargetData?.targetType?.toLowerCase() == TARGET_TYPES.MonthlyTargetPrerequistite.toLowerCase() ||
    salesTargetData?.targetType?.toLowerCase() == TARGET_TYPES.ProductTargetPrerequisite.toLowerCase();

  const downloadCSVforTargetSetup = async () => {
    try{
      const fileUrl = salesTargetData.formData.storeList;

      // Extract fileName and directory from the URL
      const fileName = fileUrl?.split('/').pop();
      const directory = fileUrl?.split('/input')[1];

      const sasResponse = await getSasToken(fileName, FILE_UPLOAD_TEMPLATE_TYPE.SALES_TARGET)
      const response = await downloadFileOnBlob(sasResponse, directory, fileName)
      if (!response && !response?.responseText) throw new Error('No response received from download')
      
      const responseText = response?.responseText

      const fileNameTemp = `Target_Template${getDateWithTimeString()}`
      downloadCSVFiles(responseText, fileNameTemp)
    } catch (error) {
      console.error('Error downloading CSV:', error)
    }
  }
  let rule;
  let mediaFile;

  if (selectedTab === 'parent') {
    rule = salesTargetData?.tabWiseData?.parent?.ruleSet?.rules?.[0]
      || salesTargetData?.ruleSet?.rules?.[0];
    mediaFile = salesTargetData?.tabWiseData?.parent?.mediaFile?.[0];
  } else if (selectedTab === 'child') {
    rule = salesTargetData?.tabWiseData?.child?.ruleSet?.rules?.[0];
    mediaFile = salesTargetData?.tabWiseData?.child?.mediaFile?.[0];
  } else {
    rule = salesTargetData?.ruleSet?.rules?.[0];
    mediaFile = salesTargetData?.mediaFile?.[0];
  }

  const includedProductIds = rule?.includedProductIds || [];
  const onDownloadClick = async () => {
    if (!includedProductIds.length) return; // Prevent download if empty
    const csvHeader = 'Product Id\n';
    const csvRows = includedProductIds.join('\n');
    const csvString = csvHeader + csvRows;
    downloadCSVFiles(csvString, mediaFile);
  };

  const SelectionProductList = () => {
    return <span>
      {
        salesTargetData?.tabWiseData?.parent?.includedProducts?.length > 0 ||
          salesTargetData?.tabWiseData?.parent?.excludedProducts?.length > 0 ? 'CURRENT LIST' : '-'
      }
    </span>
  }

  const isTemplateUploaded = (fileName) => {
  return fileName? "Yes - ": "No"
  }

  const isEditable = (status)=>{
    return  status == null || status?.toLowerCase() === Constants.Draft.toLowerCase()
  }

  const isEditTemplateVisible = useMemo(
    () =>
      (countryCode === COUNTRY_CODES.EGYPT || countryCode === COUNTRY_CODES.KSA) &&
      (status?.toLowerCase() === Constants.InProgress?.toLowerCase() ||
        status?.toLowerCase() === Constants.Published?.toLowerCase()),
    [countryCode, status]
  )
  return (
    <div className="sales-target-review">
      <Accordion
        isDark
        size="large"
        content={
          <>
            <AccordionItem
              isDark
              expanded
              label="Setup"
              content={
                <>
                  <div className="grid-container">
                    <div className="review_subtitle">Target Setup</div>
                    <div className="">
                      { isEditable(status)  &&
                        <div data-testid="targetSetupEdit" onClick={() => handleEditSection(ROUTES.SALES_TARGET_ADD)}>
                          <span className="right-align">
                            <Link label="Edit Section" iconLeading="edit">
                              <span className='flex items-center gap-1'>
                                <Icon style={{ color: "#3387df" }} icon="edit" size="small" />
                                Edit Section
                              </span>
                            </Link>
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-8">
                    <div className="grid grid-cols-1 ">
                      <div className="grid_wrap">
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Target Type</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{formData?.targetType}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Target Name</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{formData?.targetName}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Target Template</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{isTemplateUploaded(fileName)}</span>
                            <Link className="text-sky-500" onClick={() => downloadCSVforTargetSetup()}>
                              <span>{fileName}</span>
                            </Link>
                            {isEditTemplateVisible && (
                              <button
                                className="mt-2 text-blue-500 underline"
                                type="button"
                                onClick={() => setOpenUpload(true)}
                                style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
                              >
                                Edit Template
                              </button>
                            )}
                            <FileUploadWithModal
                              openUpload={openUpload}
                              setOpenUpload={setOpenUpload}
                              setFormData={setFormData}
                              formData={{...formData, targetMediaFile: [formData?.storeList]}}
                              uploadFor={Constants.SalesTargetMedia}
                              fileType="csv"
                              isCsvValidationRequired={true}
                              onTemplateUpdate={onTemplateUpdate}
                              salesTargetId={salesTargetId}
                              customRules={getTargetRules({
                                targetType: formData?.targetType,
                                numberLevel: formData?.numberLevel,
                                numberMileStone: formData?.numberMileStone,
                                countryCode: countryCode,
                              })}
                            />
                          </div>

                          {/* <div className="review_value text-white">
                            <span>
                              NO{' '}
                              <a className="text-sky-500" onClick={() => setOpenStoreListModal(true)}>
              STORE-LIST-OCT2024.CSV
            </a>
            <ReviewStoreListModal
              isOpenStoreListModal={isOpenStoreListModal}
              setOpenStoreListModal={setOpenStoreListModal}
            />
                            </span>
                          </div> */}
                        </div>
                        {/* <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Default Spend Goal</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{formData?.defaultSpendGoal}</span>
                          </div>
                        </div> */}
                        {/* <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Points to Award</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{formData?.defaultPointsAwarded}</span>
                          </div>
                        </div> */}
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Exclude tax from goal?</span>
                          </div>

                          <div className="review_value text-white">
                            <span>{getAnswer(formData?.excludeTaxFromGoal)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 ">
                      <div className="grid_wrap">

                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Include Offline Orders?</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getAnswer(formData?.offlineOrdersIncluded)}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Round up points?</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getAnswer(formData?.roundUpPointsFlag)}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Users need to join this campaign?</span>
                          </div>
                          <div className="review_value text-white">
                            {/* <span>{getAnswer(formData?.userNeedsToJoin)}</span> */}
                            <span>{getAnswer(formData?.joinCampaignFlag)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="review_subtitle">Availability </div>
                  <div className="grid grid-cols-2 gap-8">
                    <div className="grid grid-cols-1 ">
                      <div className="grid_wrap">
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Active Start Date</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getFormattedDate(formData?.startDate, false, '-', 'yyyy-mm-dd')}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Active End Date</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getFormattedDate(formData?.endDate, false, '-', 'yyyy-mm-dd')}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Display Start Date</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getFormattedDate(formData?.displayStartDate, false, '-', 'yyyy-mm-dd')}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Active and Display the same?</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getAnswer(formData?.activeDisplay)}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 ">
                      <div className="grid_wrap">
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Target Delivery Date</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getFormattedDate(formData?.targetDeliveryDate, false, '-', 'yyyy-mm-dd')}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Awards points immediately when goal is hit?</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getAnswer(formData?.awardPointsImmedFlag)}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Display End Date</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getFormattedDate(formData?.displayEndDate, false, '-', 'yyyy-mm-dd')}</span>
                          </div>
                        </div>
                        <div className="review_grid_row grid grid-cols-2 gap-y-2">
                          <div className="review_title">
                            <span>Points Delivery Date</span>
                          </div>
                          <div className="review_value text-white">
                            <span>{getFormattedDate(formData?.pointsDeliveryDate, false, '-', 'yyyy-mm-dd')}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              }
            />
            <AccordionItem
              isDark
              expanded
              label="Display Content"
              content={
                <>
                  <>
                    {isPrerequisiteTarget ? (
                      <>
                        <div className="flex justify-between items-center">
                          <TabsNavigation
                            data-testid="review-display-content-tabs"
                            className="w-70 display-content-nav w-full border-gray-700"
                            activeTabIndex={selectedTab === 'parent' ? 0 : 1}
                          >
                            {['parent', 'child'].map((tab, index) => (
                              <Tab
                                key={tab}
                                data-testid={`tab-${tab}`}
                                label={index === 0 ? 'Parent' : 'Child'}
                                className="no-icon"
                                onClick={() => handleTabChange(tab, 'display-content')}
                                isDark
                              />
                            ))}
                          </TabsNavigation>
                          {(status === Constants.Draft || status == null) &&
                            <div data-testid="displayContentEdit" onClick={() => handleEditSection(ROUTES.SALES_TARGET_DISPLAY_CONTENT)}>
                              <span>
                                <Link label="Edit Section" iconLeading="edit" >
                                  <span className='flex items-center gap-1'><Icon style={{ color: "#3387df" }} icon="edit" size="small" />Edit Section</span>
                                </Link>
                              </span>
                            </div>
                          }
                        </div>
                        <ReviewParentChildTab
                          selectedTab={selectedTab}
                          languages={languages}
                          activeLanguage={activeLanguage}
                          salesTargetData={salesTargetData}
                          section="display-content"
                        />
                      </>
                    ) : (
                      <>
                        <div className="flex justify-between items-center">
                          <TabsNavigation activeTabIndex={0} handleSetActiveTab={function Qa() { }} className="mb-5">
                            {languages &&
                              languages?.length > 0 &&
                              languages.map((lang, idx) => (
                                <Tab
                                  key={`${idx}_${lang.code}`}
                                  label={lang.title}
                                  className="no-icon"
                                  onClick={() => handleTabClick(lang.code)}
                                  isDark
                                />
                              ))}
                          </TabsNavigation>
                          {(status === Constants.Draft || status == null) &&
                            <div data-testid="displayContentEdit" onClick={() => handleEditSection(ROUTES.SALES_TARGET_DISPLAY_CONTENT)} >
                              <span>
                                <Link label="Edit Section" iconLeading="edit" >
                                  <span className='flex items-center gap-1'><Icon style={{ color: "#3387df" }} icon="edit" size="small" />Edit Section</span>
                                </Link>
                              </span>
                            </div>
                          }
                        </div>
                        <ReviewDisplayContentTab
                          languages={languages}
                          activeLanguage={activeLanguage}
                          salesTargetData={salesTargetData}
                        />
                      </>
                    )}
                  </>
                </>
              }
            />
            <AccordionItem
              isDark
              expanded
              label="Products"
              content={
                <>
                  <div className='grid-container'>
                    <div className="review_subtitle">Target Setup </div>
                    <div className="edit_align">
                      {(status === Constants.Draft || status == null) &&
                        <div data-testid="productSelectionEdit" onClick={() => handleEditSection(ROUTES.SALES_TARGET_PRODUCTS)}>
                          <span className="right-align">
                            <Link label="Edit Section" iconLeading="edit" >
                              <span className='flex items-center gap-1'><Icon style={{ color: "#3387df" }} icon="edit" size="small" />Edit Section</span>
                            </Link>
                          </span>
                        </div>
                      }
                    </div>
                  </div>


                  {isPrerequisiteTarget ?
                    <>
                      <TabsNavigation
                        data-testid="review-product-tabs"
                        className="w-70 display-content-nav mb-6 w-full border-gray-700"
                        activeTabIndex={selectedTabForProduct === 'parent' ? 0 : 1}
                      >
                        {['parent', 'child'].map((tab, index) => (
                          <Tab
                            key={tab}
                            data-testid={`tab-${tab}`}
                            label={index === 0 ? 'Parent' : 'Child'}
                            className="no-icon"
                            onClick={() => handleTabChange(tab, 'product')}
                            isDark
                          />
                        ))}
                      </TabsNavigation>
                      <ReviewParentChildTab
                        selectedTab={selectedTabForProduct}
                        languages={languages}
                        activeLanguage={activeLanguage}
                        salesTargetData={salesTargetData}
                        getSelectedCategoryTitle={getSelectedCategoryTitle}
                        section="product"
                        preRequisiteParentTabData={preRequisiteParentTab}
                        preRequisiteChildTabData={preRequisiteChildTab}
                        getFilteredProducts={getFilteredProducts}
                      />
                    </>
                    :
                    <>
                      {selectedType === Constants.CategoryProducts ? <>
                          <div className="grid grid-cols-2 gap-8">
                            <div className="grid grid-cols-1 ">
                              <div className="grid_wrap">
                                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                                  <div className="review_title">
                                    <span>Ignore SKU List</span>
                                  </div>
                                  <div className="review_value text-white">
                                    <span>{getAnswer(salesTargetData?.tabWiseData?.parent?.ignoreSkuList)}</span>
                                  </div>
                                </div>
                                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                                  <div className="review_title">
                                    <span>Product Selection</span>
                                  </div>
                                  <div className="review_value text-white">
                                    <SelectionProductList />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="grid grid-cols-1 ">
                              <div className="grid_wrap">
                                <div className="review_grid_row grid grid-cols-2 gap-y-2">
                                  <div className="review_title">
                                    <span>Category</span>
                                  </div>
                                  <div className="review_value text-white">
                                    <span>{getSelectedCategoryTitle()}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <ReviewProductsTable
                            displayedProducts={tableData.displayedProducts}
                            isLoading={tableData.isLoading}
                            hasMoreData={tableData.hasMoreData}
                            totalProducts={tableData.totalProducts}
                            onScroll={tableData.handleScroll}
                            containerRef={tableData.tableContainerRef}
                            itemsPerPage={tableData.itemsPerPage}
                          />
                      </> :
                        <>
                          <div className="grid">
                            <div className="grid_wrap flex flex-direction-row">
                              <ReviewRow label="Product List" value={salesTargetData?.tabWiseData?.parent?.mediaFile[0]} />
                              <ButtonIcon
                                icon="file_download"
                                isDark
                                size="medium"
                                type="default"
                                data-testid="file_download"
                                onClick={onDownloadClick}
                              />
                            </div >
                          </div >
                        </>}
                    </>
                  }
                </>
              }
            />
          </>
        }
      />
    </div >
  )
}
export default ReviewAccordion
